import { createSlice } from '@reduxjs/toolkit';

import { AssignedTest } from '../../../pages/AssignedTests';

import { scheduleApi } from './../../../services/scheduleTestApi/index';
import { Assignee } from './types';

export type ResultsState = {
  headerTitle: string;
  scheduleStudentTestsData: {
    currentpage: number;
    pagesize: number;
    totalpages: number;
    totaltests: number;
    data: AssignedTest[] | [];
  };
  associatedStudents?: Assignee[];
};

const initialState: ResultsState = {
  headerTitle: 'Dashboard',
  scheduleStudentTestsData: {
    currentpage: 0,
    pagesize: 0,
    totalpages: 0,
    totaltests: 0,
    data: []
  },
  associatedStudents: []
};

const scheduleTestSlice = createSlice({
  name: 'scheduleTest',
  initialState,
  reducers: {
    setHeaderTitle: (state, action) => {
      state.headerTitle = action.payload;
    }
  },
  extraReducers: builder => {
    builder.addMatcher(
      scheduleApi.endpoints.getStudentScheduleTests.matchFulfilled,
      (state, action) => {
        state.scheduleStudentTestsData = action?.payload;
      }
    );
    builder.addMatcher(
      scheduleApi.endpoints.fetchAssociatedStudents.matchFulfilled,
      (state, action) => {
        state.associatedStudents = action?.payload?.data;
      }
    );
  }
});

export const { setHeaderTitle } = scheduleTestSlice.actions;

export default scheduleTestSlice.reducer;
